// System dependencies

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Application dependencies

import { ProductNameTitle } from '@/interfaces/authorisation/product.interfaces';
import { RootState } from '@/redux/store';
import { User, UserFields, UserRedux } from '@/interfaces/authorisation/user.interfaces';

// State

const initialState: UserRedux = {
  [UserFields.NonPortalProduct]: null,
  [UserFields.PortalProduct]: null,
  [UserFields.User]: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState: initialState,
  reducers: {
    userLoadNonPortalProduct: (state, action: PayloadAction<ProductNameTitle | null>) => {
      state[UserFields.NonPortalProduct] = action.payload;
    },
    userLoadPortalProduct: (state, action: PayloadAction<ProductNameTitle | null>) => {
      state[UserFields.PortalProduct] = action.payload;
    },
    userLoadUser: (state, action: PayloadAction<User | null>) => {
      state[UserFields.User] = action.payload;
    },
  },
});

export const { userLoadNonPortalProduct, userLoadPortalProduct, userLoadUser } = userSlice.actions;

export const getUserSelector = (state: RootState) => state.user;

export default userSlice.reducer;
